import axios from 'axios';

import { BASE_URL } from '../../inc/constants';
import {fetchPostError,fetchPostStarted,fetchPostSuccess, postPostAction, putPostAction} from './actions';
import { AppState } from '..';
import { handleCache } from '../base/functions';
import { Post } from '../categories/types';
import { fetchCategories } from '../categories/functions';

export const fetchPostItem = (id: number) => {
    return (dispatch: any,getState: any) =>  {
        dispatch(fetchPostStarted());
        let state:AppState = getState();
        const headers = {Authorization: `token ${state.base.token}`};
        axios.get(`${BASE_URL}/posts/${id}/`,{headers})
        .then(res => {
            dispatch(fetchPostSuccess(id,res.data));
        })
        .catch(err => {
            dispatch(fetchPostError(err));
            handleCache(dispatch,err);
        });

    };
};

export const postPost = (id: number,post: Post,then?: Function) => {
    return (dispatch: any,getState: any) =>  {
        dispatch(fetchPostStarted());
        let state:AppState = getState();
        const headers = {Authorization: `token ${state.base.token}`};
        axios.post(`${BASE_URL}/posts/`,post,{headers})
        .then((res) => {
            dispatch(postPostAction(id));
            return res.data;
        })
        .then((json :any)=>{
            dispatch(fetchCategories());
            if(then) {
                then(json);
            }
        })
        .catch(err => {
            dispatch(fetchPostError(err));
            handleCache(dispatch,err);
        });
    };
};
export const putPost = (id: number,post: Post,then?: Function) => {
    return (dispatch: any,getState: any) =>  {
        dispatch(fetchPostStarted());
        let state:AppState = getState();
        const headers = {Authorization: `token ${state.base.token}`};
        axios.put(`${BASE_URL}/posts/${id}/`,post,{headers})
        .then((res) => {
            dispatch(putPostAction(id));
            return res.data;
        })
        .then((obj:any)=>{
            if(then) {
                then(obj);
            }
        })
        .catch(err => {
            dispatch(fetchPostError(err));
            handleCache(dispatch,err);
        });
    };
};


//externals
export function finder(id: any,data: any[]) {
    return data.findIndex((v)=>v.id==id)
}